<template>
  <a-button
    :icon="icon"
    :type="type"
    :data-cy="dataCy"
    :loading="loading"
    :disabled="disabled"
    :block="block"
    :size="size"
    :html-type="isSubmitType ? 'submit' : 'button'"
    :class="{ 'blue-link': isBlueLink }"
    @click="onClick"
  >
    <!-- @slot Use this slot to place content inside button. -->
    <slot>
      <div v-if="externalLinkButton" class="external-link-button">
        {{ text }}
        <ExternalLinkIcon color="currentColor" />
      </div>
      <template v-else>{{ text }}</template>
    </slot>
  </a-button>
</template>

<script setup lang="ts">
import ExternalLinkIcon from '@/components/icons/ExternalLinkIcon.vue'

export type ButtonType = 'primary' | 'secondary' | 'link' | 'dashed' | 'danger'
type ButtonSize = 'small' | 'large' | 'default'
export type ButtonProps = {
  block?: boolean
  dataCy?: string
  disabled?: boolean
  externalLinkButton?: boolean
  icon?: string
  isSubmitType?: boolean
  isBlueLink?: boolean
  loading?: boolean
  size?: ButtonSize
  /**
   * @deprecated use default slot instead
   */
  text?: string
  type?: ButtonType
}

withDefaults(defineProps<ButtonProps>(), {
  block: false,
  disabled: false,
  isBlueLink: false,
  isSubmitType: false,
  loading: false,
  size: 'default',
  text: '',
  type: 'primary'
})

const emit = defineEmits<{
  (event: 'click', value: PointerEvent): void
}>()

const onClick = (event: PointerEvent) => {
  emit('click', event)
}
</script>

<style lang="scss" scoped>
.ant-btn :deep(> span::first-letter) {
  text-transform: capitalize;
}

.external-link-button {
  display: flex;
  column-gap: 8px;
  align-items: center;
  justify-content: center;
}
</style>
